export const SHOP_BY_VEHICLE_TITLE = 'SHOP TIRES BY VEHICLE'
export const SHOP_BY_VEHICLE_DESCRIPTION = 'Explore our vast inventory of tires'
export const SHOP_BY_SIZE_TITLE = 'SHOP TIRES BY SIZE'
// eslint-disable-next-line
export const SHOP_BY_SIZE_DESCRIPTION = "Enter your vehicle's tire size here"
export const SHOP_BY_BRANDS_TITLE = 'SHOP BY BRANDS'
// eslint-disable-next-line
export const SHOP_BY_BRANDS_DESCRIPTION = "The world's best tire brands together under one roof"
export const APPOINTMENT_DESCRIPTION = 'Need help? Shop Tires, Services, & Deals in store'

export const INITIAL_HOVER_DATA = {
  byVehicle: false,
  bySize: false,
  byBrand: false,
  appointment: false
}
